import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-related-pages',
    templateUrl: './block-related-pages.component.html',
})

export class BlockRelatedPagesComponent extends BlockAbstractComponent implements OnInit {

}
